import {Icon} from 'ant-design-vue';
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2381663_bz6me5lqz4q.js'
})
export {
  IconFont
}